module.exports = __webpack_public_path__ + "media/react/payments/pages/add_ons/assets/mba_admissions/headshot_eric-92d02c77cd07cc8ea7df2730d112605a.png";